module.exports = __webpack_public_path__ + "img/wx-share.cb9195f9.png";